import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { FadeUp } from "./Reveal";

const FILMS = [
  {
    src: "/photos/americano.mp4",
    poster: "/photos/americano-poster.jpg",
    title: "AMERICANO",
    note: "A TapeShift highlight film",
  },
];

const FilmCard = ({ film, index }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (playing) {
      v.pause();
      setPlaying(false);
    } else {
      v.play();
      setPlaying(true);
    }
  };

  return (
    <FadeUp delay={index * 0.1}>
      <figure>
        <div
          className="relative overflow-hidden rounded-sm aspect-video cursor-pointer group"
          onClick={toggle}
          data-testid={`film-player-${index}`}
        >
          <video
            ref={videoRef}
            src={film.src}
            poster={film.poster}
            playsInline
            loop
            preload="metadata"
            className="photo-tone w-full h-full object-cover"
            data-testid={`film-video-${index}`}
          />
          {!playing && (
            <div className="absolute inset-0 flex items-center justify-center bg-[#0A0A0A]/45">
              <span
                data-testid={`film-play-btn-${index}`}
                className="w-20 h-20 md:w-24 md:h-24 rounded-full border border-[#C9A26B]/70 flex items-center justify-center bg-[#0A0A0A]/40 backdrop-blur-sm text-[#C9A26B] group-hover:bg-[#C9A26B] group-hover:text-[#0A0A0A] transition-colors duration-500"
              >
                <Play className="w-7 h-7 md:w-8 md:h-8 ml-1" fill="currentColor" />
              </span>
            </div>
          )}
        </div>
        <figcaption className="mt-4 flex items-baseline justify-between">
          <span className="text-sm text-[#A3A3A3]">{film.title} — {film.note}</span>
          <span className="font-accent text-xs tracking-[0.3em] text-[#C9A26B]">{String(index + 1).padStart(2, "0")}</span>
        </figcaption>
      </figure>
    </FadeUp>
  );
};

export const Films = () => (
  <section id="films" className="px-6 md:px-12 py-28 md:py-44 bg-[#0A0A0A] border-t border-white/5" data-testid="films-section">
    <FadeUp className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-6">
      <div>
        <p className="text-xs tracking-[0.4em] uppercase text-[#C9A26B] mb-4">Films</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#F5F4F0] leading-[1.05]">
          Love, in <span className="font-accent italic text-[#C9A26B]">motion</span>
        </h2>
      </div>
      <p className="text-sm text-[#525252] max-w-xs leading-relaxed">
        Press play — sound on. These are the days as they truly sounded and moved.
      </p>
    </FadeUp>
    <div className="flex flex-col gap-16">
      {FILMS.map((f, i) => (
        <FilmCard key={f.src} film={f} index={i} />
      ))}
    </div>
  </section>
);
